// initial data

export default {
  userId: null,
  isLoggedIn: false,
};
